<template>
  <!--  <lazy-dom>-->
  <div class="policy-form">
    <div class="flex">
      <div class="main flex-1 mg-l-40">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Insurer Quote Status</span>
              <el-form-item
                ref="quote_status"
              >
                <v-radio-group
                  v-model="formData.quote_status"
                  :border="true"
                  button
                  :rules="rules.select"
                  :list="quoteStatusOptions" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Total Payable</span>
              <span>{{ formData.payable||0 }}</span>
            </div>
          </div>
          <template  v-if="formData.quote_status == 0&&editType==3">
            <div class="box">
              <div class="form-item form-half">
                <span>Insurer</span>
                <el-form-item
                  ref="company_id"
                  prop="company_id">
                  <v-select
                    v-model="formData.company_id"
                    :list="newSMEOptions.insurer"
                    disabled
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Plan Name</span>
                <el-form-item
                  ref="plan_name"
                  :rules="rules.input"
                  prop="plan_name"
                >
                  <v-input
                    v-model="formData.plan_name"
                    disabled
                  />
                </el-form-item>
              </div>
            </div>
            <div
              class="form-item form-half">
              <span>Reject Renewal Notice</span>
              <el-form-item
                ref="renew_file_path_id"
                :rules="rules.upload"
                prop="renew_file_path_id">
                <v-upload
                  card
                  widthFull
                  :fileData="formData.renew_file"
                  :otherData="{
                    idKey: 'renew_file_path_id',
                    target: 'renew_file',
                    name: ''
                  }"
                  @delete="handlerDeleteQuoFiles"
                  @uploadSuccess="handlerUploadSuccess" />
              </el-form-item>
            </div>
          </template>
          <template v-if="formData.quote_status !=0&&editType==3||editType!=3">
            <reply-form
              ref="reply-form"
              :orgin-form="form"
              :form="formData"
              is-refer
              :is-fina="isFina"
              :amount.sync="formData.payable"
              @updateName="handleUpdateName"></reply-form>
          </template>
        </el-form>
      </div>
    </div>
  </div>
  <!--  </lazy-dom>-->
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import MixinSameReplyRefer from '@/mixins/sme-reply-refer'
import replyForm from '@/views/sme/components/reply-form'
import {replySMEQuoteDetail,replySMEQuoteCal} from '@api/new_sme'
import {mapState} from 'vuex'
import OMath from '@/utils/math'
export default {
  name: 'reply-sme-refer-form',
  components: {replyForm},
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props:{
    form:{
      type:Object,
      default:()=>({})
    },
    item:{
      type:Object,
      default:()=>({})
    },
    isFina:{
      type:Boolean,
      default:false
    },
    editType: {
      type: Number,
      default: 1 // 1 - reply, 2 - upgrade, 3 - renew
    },
    customerId: {
      type: [Number,String],
      default: '' // 1 - reply, 2 - upgrade
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    renewOrderId: {
      type: [Number, String],
      default: 0
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    index: [String, Number],
  },
  data() {
    return{
      detailData:{},
      formData:{
        quote_status:'',
        renew_file:{},
        renew_file_path_id:'',
        payable:''
      },
      reply_content:'',
      refer_inter_quo_files:{},
      oldFormDataLock: -1,
      plan_name:'',
      company_id:''
    }
  },
  computed:{
  },
  watch:{
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    item: {
      immediate: true,
      handler(val) {
        if(this.formDataLock !== this.oldFormDataLock) {
          this.oldFormDataLock = this.formDataLock
          if(val)
            this.formData = {...val, order_id: this.form.order_id}
        }
      }
    }
  },
  mounted() {
  },
  methods:{
    handleUpdateName({company_id,plan_name}){
      this.$emit('update:companyId',company_id)
      this.$emit('update:plan',plan_name)
    },
    // 文件上傳成功
    handlerUploadSuccess({ data, result, otherData }) {
      const { target, idKey, fileIndex = '', name,type } = otherData
      const { id, path,thumb_url,url } = data
      this.$set(this.formData,target,data)
      this.formData[idKey] =id
    },
    handlerDeleteQuoFiles({otherData}){
      let { type, index,target,idKey } = otherData
      this.$set(this.formData,target,{})
      this.formData[idKey] =''
    },
    getFormData(data){
      this.formData= {...this.formData,...data}
    },
    validateForm(otherData){
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async(valid, rules) => {
          if( valid){
            try {
              let params = JSON.parse(JSON.stringify(this.formData))
              let { quote_status, renew_file,renew_file_path_id } = params || {}
              let data = {}
              if(quote_status!=0)
                data = await this.$refs['reply-form'].submitForm() // 确保 submitForm 不会 reject
              this.$emit('validate', otherData)
              resolve({ ...params, ...data, renew_file,renew_file_path_id, quote_status })
            } catch (err) {
              reject('submitForm failed')
            }
          }else
          {
            this.scrollToValidDom(rules)
            reject('false')
          }
        })
      })
    },
  }

}
</script>

<style lang="scss" scoped>
.el-button--danger__color{
  color: #D73A49;
}
.el-button--primary__color{
  background: #2EA44F;
  color: #fff;
}
.reply-refer {
  position: relative;
  .abs-top-right {
    top: 5px;
    //right: 15px;
  }
  .bottom-border{
    border-bottom: 1px solid #dddfe7;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
}
.star {
  display: block;
  margin-right: 7px;
  width: 18px;
  height: 18px;
  background: #F7B500;
  clip-path: polygon(9px 0, 12px 6px, 18px 6px, 14px 12px, 16px 18px, 9px 14px, 2px 18px, 4px 12px, 0px 6px, 6px 6px);
}

.star-remark {
  display: flex;
  align-items: center;;
  margin-bottom: 15px;
  padding: 10px 15px;
  color: #91939A;
  background: #E9E9EB;
  .star {
    display: block;
    margin-right: 7px;
    width: 18px;
    height: 18px;
    background: #F7B500;
    clip-path: polygon(9px 0, 12px 6px, 18px 6px, 14px 12px, 16px 18px, 9px 14px, 2px 18px, 4px 12px, 0px 6px, 6px 6px);
  }
}
.main-left {
  margin-right: 20px;
  width: 300px;
  ul {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #D1D5DA;
    li {
      display: flex;
      align-items: center;
      padding: 15px;
      color: #fff;
      font-size: 16px;
      list-style: none;
      word-break: break-word;
      cursor: pointer;
      border-radius: 6px;
      background: #0366D6;
      &.active {
      }
      .el-checkbox {
        margin-right: 10px;
      }
      .star {
        margin-right: 10px;
      }
    }
  }
}
.icon{
  margin-right: 15px;
  img{
    height: 22px;
    width: 22px;
  }
}
.icon-content{
  height: 22px;
  width: 22px;
  border-radius: 5px;
  background-color: #E1E4E8;
  color: #6A737D;
  font-size: 14px;
  text-align: center;
  line-height: 22px;
}
.del_line{
  text-decoration: line-through
}
.box-remark{
  .title{
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
  }

  .remark-add {
    z-index: 2;
    margin: 0 -15px;
    padding: 15px 15px 0 15px;
    //border-top: 1px solid #dddfe7;
  }

  .remarks-container {
    z-index: 1;
    max-height: 300px;
    overflow-y: auto;

    .remark-box {
      margin-bottom: 10px;
      font-size: 12px;
      color: #91939a;

      .remark-header {
        display: flex;
        justify-content: space-between;

        span:first-child {
          font-weight: bold;
        }
      }

      p {
        padding-bottom: 10px;
        color: #616266;
      }
    }
  }
}
</style>
